<template>
<div>

   <switch-languages></switch-languages>

   <div class="flex justify-center items-center min-h-[100vh] w-[100vw] py-[6rem] bg-[#F2F5F7]">
      <div class="flex flex-col max-w-[85vw] w-[750px]">
         <div class="flex flex-col items-center max-w-[750px] mb-3">
            <div class="flex justify-between items-center gap-5 w-full">
               <img class="mb-3 rounded-lg w-[85px] h-[85px]" src="@/assets/img/intestations/agency-transparent.png"/>
               <img class="mb-3 rounded-lg w-[85px] h-[85px]" src="@/assets/img/intestations/models-transparent.png"/>
            </div>          
         </div>
         <the-card >

            <div style="overflow: hidden">

               <div>
                  <v-form
                     ref="change_pass"
                     v-model="valid_change_pass"
                  >  

                     <div class="max-w-[550px] mx-auto my-2">
                        <registration-title :title="$t('Eliminazione utente')"></registration-title>
                        <div class="text-center">
                              <p>
                                 {{ $t('Ci dispiace vederti andare via. Ti ricordiamo che eliminando definitivamente il tuo profilo sul portale di BeA agency perderai la possibilità di ricevere le nostre offerte di lavoro per eventi, promozioni e servizi fotografici (hostess, steward, modelli, promoter...).Vuoi davvero procedere con l\'eliminazione definitiva del profilo e rinunciare a collaborare con noi?') }}
                              </p>
                           </div>
                        <div>
                           <div v-if="!confirm_delete" class="grid grid-cols-1 gap-[.5rem] divide-y divide-grey">
                              <div class="pb-[1rem] flex flex-col gap-2 items-center">

                                 <div class="grid grid-cols-1 gap-[.5rem] md:grid-cols-2 mt-4">
                                    <router-link :to="'/login'" class="w-full">
                                       <v-btn v-if="!show_success" color="primary" dark block  @click="deleteUser()">{{$t('Ci ho ripensato, torna al login')}}</v-btn>
                                    </router-link>
                                    <v-btn v-if="!show_success" color="error" :loading="isLoading" dark block  @click="deleteUser()">{{$t('Elimina utente')}}</v-btn>
                                 </div>
                                 <v-alert  type="success"  v-if="show_success">
                                    Utente eliminato con successo
                                 </v-alert>
                                 <!-- <router-link :to="'/login'">{{$t('Torna al login')}}</router-link> -->
                              </div> 
                           </div>

                           <div v-if="confirm_delete" class="mt-3">
                              <v-alert type="success" >
                                 Utente eliminato con successo
                              </v-alert>
                              <router-link :to="'/login'" class="w-full">
                                 <v-btn color="primary" dark block >{{$t('Torna alla pagina iniziale')}}</v-btn>
                              </router-link>
                           </div>

                           <div class="mt-2">
                              <v-alert type="error" @click="show_error = false" v-if="show_error">
                                 Ops! Si è verificato un errore
                              </v-alert>
                           </div>
                           
                           <v-progress-linear
                              v-if="isLoading"
                              color="primary"
                              indeterminate
                           ></v-progress-linear>
                        </div>
                     </div>

                  </v-form>
               </div>

            </div>

         </the-card>
      </div>
   </div>
</div>
</template>

<script>
// import moment from 'moment';
import SwitchLanguages from "@/components/SwitchLanguages.vue";

export default {
   name: "DeleteUser",
   components: {
      SwitchLanguages
   },
   data() {
      return {
         hash: null,
         show_error: false,
         show_success: false,

         isLoading: false,
         error: null,

         confirm_delete: false,

         loader: true,
      };
   },
   watch: {

   },
   methods: {
      async deleteUser(){
         this.show_error = false;
         this.isLoading = true;
         await this.$store.dispatch("deleteUser",{
            hash: this.hash
         }).then(res => {
            if(res.response.deleted || res.response.soft_deleted){
               this.show_success = true;
            }
            else{
               throw new Error(res.response.message);
            }
         }).catch(err => {
            this.show_error = true;
            console.log("err",err);
         }).finally(() => {
            this.isLoading = false;
         });
         this.confirm_delete = true;
      },
   },
   async created () {
      this.hash = this.$route.query.hash ?? null;

      if(!this.hash ){

         // se utente loggato, lo redirigo alla home altrimenti alla login
         if(this.$store.getters.isAuthenticated){
            this.$router.replace("/");
         } else {
            this.$router.replace("/login");
         }
      }
         
   },
};
</script>

<style lang="scss" scoped>

.fade-enter-active,
.fade-leave-active {
    transition: opacity .5s
}

.fade-enter,
.fade-leave-to {
    opacity: 0
}

.login {
   &--page {
      background-size: cover;
      background-position: bottom;
      position: relative;
      height: 100vh;
      display: flex;
      justify-content: center;
      align-items: center;

      &:after {
         @include AfterFullContainer();
         z-index: 1;
         background: rgba($black, 0.3);
      }
   }

   &--wrapper {
      position: relative;
      z-index: 4;
      max-width: 1200px;
      width: 100%;
   }

   &--row {
      justify-content: center;
      max-width: calc(100vw + 24px);
   }

   &--col {
     display: flex;
      justify-content: center;
      align-items: center;
      &__login {
         justify-content: flex-end;
      }
      &__news {
         justify-content: flex-start;
         align-items: flex-start;
         display: flex;
         flex-direction: column;
      }
      @media screen and (max-width: 1200px) {
         justify-content: center;
         align-items: center;
      }
   }

   &--news {
      position: relative;

      width: 500px;
      max-width: 90vw;
      display: flex;
      flex-direction: column;
      padding: 2rem;
      color: $black !important;

      border-radius: 6px;
      background: rgba(255, 255, 255, 0.65);

      box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.37);
      backdrop-filter: blur(11px);

      @include box-shadow();

      &:not(:first-child) {
         margin-top: 1rem;
      }

      .v-icon {
         position: absolute;
         top: 5px;
         right: 5px;
         opacity: 0.5;
         transition: opacity 0.3s ease;
         &:hover {
            opacity: 1;
         }
      }
   }

   &--card {
      position: relative;
      height: fit-content;
      width: 500px;
      max-width: 90vw;
      display: flex;
      flex-direction: column;
      padding: 3.5rem;
      border-radius: 6px;
      background: rgba(255, 255, 255, 0.65);

      box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.37);
      backdrop-filter: blur(11px);

      @include box-shadow();
   }

   &--img {
      position: absolute;
      top: 0;
      left: 50%;
      transform: translate(-50%, -50%);

      display: flex;
      align-items: center;
      justify-content: center;

      overflow: hidden;
      border-radius: 100px;
      height: 75px;
      width: 75px;
      background: white;
      @include box-shadow();
      img {
         height: 80%;
         width: 80%;
      }
   }
}
.v-progress-linear {
   position: absolute;
   bottom: 0;
   left: 0;
   right: 0;
}
</style>